import { IApplicationState } from '../../types/redux';

export const selectSuggestionsLoading = (state: IApplicationState) => state.suggestions.isLoading;
